/* eslint-disable react/display-name */
/* eslint-disable import/no-anonymous-default-export */
import React from 'react';
import styled from 'styled-components';

import { Avatar } from '~/_legacy/components/atoms/avatar/index';

import { media } from '~/utils';

export default function (props) {
  const { org } = props;

  return (
    <Wrapper>
      <Title>フォロワー</Title>
      <Count>{org.followerCount} 人</Count>
      <Users>
        {org.followers.map((u, i) => (
          <UserIconWrapper key={i}>
            <Avatar size={'40px'} border={'1px solid #fff'} src={u.avatar} />
          </UserIconWrapper>
        ))}
      </Users>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  background: #fff;
  height: 80px;
  border-radius: 10px;
  display: flex;
  flex-direction: row;

  ${media.mid`
    border-radius: 0;
  `}
`;

const Title = styled.div`
  margin-top: 5px;
  margin-left: 10px;
  font-size: 12px;
  font-weight: bold;
  color: #2c2c2c;
`;

const Count = styled.div`
  margin-left: 10px;
  height: 80px;
  line-height: 80px;
  font-size: 20px;
  font-weight: bold;
  color: #2c2c2c;
`;

const Users = styled.div`
  margin-left: 80px;
  height: 80px;
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const UserIconWrapper = styled.div`
  margin-left: -10px;
`;
